import firebaseInstance from "../../../util/firebase";

export default {
  loading(state, item) {
    state.commit("LOADING", item);
  },
  clearState(state, item) {
    state.commit("CLEAR_STATE", {});
  },
  clearProjectState(state, item) {
    state.commit("CLEAR_PROJECT_STATE", {});
  },
  getNews(state, item) {
    firebaseInstance
      .database()
      .ref("news")
      .once("value", snap => {
        var news = snap.val();
        console.log("news", news);
        state.commit("SAVE_NEWS", news);
      })
      .catch(error => {
        console.log("Error getting company data", error);
      });
  }
};
